import { MigratableJson } from '../MigratableJson';
import { CONTENT_BLOCK_NAME } from '@builder4/shared/utils/constants';

/**
 * Migration v10: Change Container overflow prop from 'hidden' to 'visible'
 *
 * This migration:
 * 1. Finds all Container nodes in the JSON
 * 2. Changes overflow prop from 'hidden' to 'visible' if it exists
 */
export default function toV10<T extends MigratableJson>(data: T): T {
  const allNodes = data.getAllNodes();

  for (const { node } of allNodes) {
    if (node.displayName !== CONTENT_BLOCK_NAME) continue;

    const props = { ...(node.props || {}) } as Record<string, unknown>;

    // Update main overflow prop
    if (props.overflow === 'hidden') {
      props.overflow = 'visible';
    }

    node.props = props;
  }

  return data;
}
